<template>
  <v-app id="app">
    <navbar></navbar>
    <router-view />
    <div class="update-dialog" v-if="prompt">
      <div class="content">
        Se encuentra una nueva versión. ¿Actualizar para cargarlo?
      </div>
      <div class="actions">
        <button class="button confirm" @click="update">Actualizar</button>
        <button class="button cancel" @click="prompt = false">Cancelar</button>
      </div>
    </div>
    <loader />
    <modal></modal>
  </v-app>
</template>

<script>
import Navbar from './components/Navbar';
import Loader from './components/Misc/Loader';
import Modal from './components/Misc/Modal.vue';
export default {
  name: 'App',
  components: {
    Navbar,
    Loader,
    Modal,
  },
  data() {
    return {
      prompt: false,
    };
  },
  created() {
    // this.$vuetify.theme.dark = true
    if (this.$workbox) {
      this.$workbox.addEventListener('waiting', () => {
        this.prompt = true;
      });
    }
  },
  methods: {
    async update() {
      this.prompt = false;
      await this.$workbox.messageSW({ type: 'SKIP_WAITING' });
    },
  },
};
</script>
<style lang="scss">
#app {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.update-dialog {
  position: fixed;
  left: 50%;
  bottom: 70px;
  transform: translateX(-50%);
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  padding: 12px;
  max-width: 576px;
  color: white;
  background-color: #2c3e50;
  text-align: left;

  .actions {
    display: flex;
    margin-top: 8px;
  }

  .button {
    margin-right: 8px;

    &.confirm {
      margin-left: auto;
    }
  }
}
</style>
